<div class="pagination-container" [class.disabled]="disabled">
  <!-- Left Section: Page Size and Info -->
  @if (totalItems > 0) {
    <div class="pagination-left">
      <!-- Page Size Selector -->
      @if (showPageSizeSelector) {
        <div class="page-size-group">
          <span class="page-size-label">Items per page:</span>
          <mat-form-field class="page-size-field">
            <mat-select
              [(value)]="pageSize"
              (selectionChange)="onPageSizeChange()"
              [disabled]="disabled"
              panelClass="pagination-select-panel">
              @for (size of pageSizeOptions; track size) {
                <mat-option [value]="size">
                  {{ size }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- Page Info inline -->
          @if (showPageInfo) {
            <span class="page-info-text">
              {{ startItem }} - {{ endItem }} of {{ totalItems }} items
            </span>
          }
        </div>
      }
    </div>
  }

  <!-- Pagination Controls -->
  @if (totalPages > 1) {
    <div class="pagination-controls">
      <!-- First Page Button -->
      @if (showFirstLastButtons) {
        <button
          mat-icon-button
          [disabled]="isFirstPage || disabled"
          (click)="goToFirstPage()"
          matTooltip="First page"
          class="nav-button first-button">
          <mat-icon>first_page</mat-icon>
        </button>
      }

    <!-- Previous Page Button -->
    <button
      mat-icon-button
      [disabled]="!hasPreviousPage || disabled"
      (click)="goToPreviousPage()"
      matTooltip="Previous page"
      class="nav-button prev-button">
      <mat-icon>chevron_left</mat-icon>
    </button>

      <!-- Page Numbers -->
      <div class="page-numbers">
        <!-- Show ellipsis for first page if needed -->
        @if (visiblePages[0] > 1) {
          <span class="ellipsis">...</span>
        }

        <!-- Page Number Buttons -->
        @for (page of visiblePages; track page) {
          <button
            mat-button
            [class.active]="page === currentPage"
            [disabled]="disabled"
            (click)="goToPage(page)"
            class="page-button">
            {{ page }}
          </button>
        }

        <!-- Show ellipsis for last page if needed -->
        @if (visiblePages[visiblePages.length - 1] < totalPages) {
          <span class="ellipsis">...</span>
        }
      </div>

    <!-- Next Page Button -->
    <button
      mat-icon-button
      [disabled]="!hasNextPage || disabled"
      (click)="goToNextPage()"
      matTooltip="Next page"
      class="nav-button next-button">
      <mat-icon>chevron_right</mat-icon>
    </button>

      <!-- Last Page Button -->
      @if (showFirstLastButtons) {
        <button
          mat-icon-button
          [disabled]="isLastPage || disabled"
          (click)="goToLastPage()"
          matTooltip="Last page"
          class="nav-button last-button">
          <mat-icon>last_page</mat-icon>
        </button>
      }
    </div>
  }

  <!-- No Items Message -->
  @if (totalItems === 0) {
    <div class="no-items">
      <span class="no-items-text">No items to display</span>
    </div>
  }
</div>
